import { Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from './_http';

// 대가의 타이밍 리스트 조회
type GetMarketTimingParams = Ref<{
	category: '한국시장' | '미국시장' | '일본시장' | '업종(한국)';
}>;
export type GetMarketTimingData = {
	market_timing: GetMarketTimingCountry;
};
export type GetMarketTimingCountry = {
	한국시장?: MarketTiming[];
	미국시장?: MarketTiming[];
	일본시장?: MarketTiming[];
	'업종(한국)'?: MarketTiming[];
};
export type MarketTiming = {
	market_timing_title: string;
	market_timing_content: string;
};
export const useGetMarketTimingApi = (params: GetMarketTimingParams) => {
	const url = '/v1/front/usa/getMarketTiming';
	return useQuery<AxiosResponse, AxiosError, GetMarketTimingData>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params.value),
		select: (res) => {
			return res.data?.data;
		},
	});
};
